import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { BibItem } from '../../providers/item/item';
import { AppState } from '../../config/state';
/**
 * Generated class for the CoDigitalSummaryComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-digital-summary',
  templateUrl: 'co-digital-summary.html'
})
export class CoDigitalSummaryComponent {
  @Input('bibDetails') bibDetails: BibItem;
  @Input('novelistDetails') novelistDetails: any;
  @Input('description') description: any;
  @Input('rating') rating: any;
  @Input('small')  small: boolean;
  @Input('availability') availability: any;
  private DESC_MAX_CHARS: number = 300;
  public updateObserver: Subject<Array<number>>;
  coverImage: string;
  errorImage: string;
  fullDescription: string;
  shortDescription: string;
  showFullDescription: boolean = false;
  charCount: number;
  author: string;
  constructor(private state: AppState) {}

  ngOnInit(): void {
    this.updateObserver = new Subject();
    if (this.bibDetails.author) this.author = this.bibDetails.author;
    this.fullDescription = this.description || '';
  }
  ngOnChanges() {
    let server = Math.floor(Math.random() * 9);
    this.errorImage = `http://covers${server}.communico.co/gen/cover?title=` + encodeURIComponent(this.bibDetails.title);
    if (this.bibDetails.imageLinks && this.bibDetails.imageLinks.length > 0){
      this.coverImage = this.bibDetails.imageLinks[0].url;
    } else if (this.bibDetails.upcs && this.bibDetails.upcs.length>0) {
      this.coverImage = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bibDetails.upcs[0]}`;
    } else if(this.bibDetails.isbns && this.bibDetails.isbns.length>0){
      if (this.bibDetails.isbns[0] == null && this.bibDetails.isbns.length > 1){
        this.coverImage = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bibDetails.isbns[1]}`;
      } else {
        this.coverImage = `https://${this.state.client.keyword}.libnet.info/getcover/${this.bibDetails.isbns[0]}`;
      }
    }else{
      this.coverImage = this.errorImage;
    }
    setTimeout(()=>this.checkDescriptionLength(), 0);

  }

  ngAfterViewInit(): void {
    if (this.description){
      setTimeout(()=>this.checkDescriptionLength(), 0);
    }
  }

  checkDescriptionLength(): void {
    if(this.description && this.description.length > this.DESC_MAX_CHARS){
      this.shortDescription = this.description.substring(0, this.DESC_MAX_CHARS)+'...';
    } else {
      this.showFullDescription = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-digital-summary/co-digital-summary.ts